import * as angular from "angular";
import {DefaultGroupDetailController} from "./default-group-detail.controller";
const templateUrl = require("./default-group-detail.html");

export const defaultGroupDetail: angular.IComponentOptions = {
    templateUrl: templateUrl,
    controller: DefaultGroupDetailController,
    controllerAs: "vm",
    bindings: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/group-detail/default-group-detail.ts
 **/